var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBLBASEINFO" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && !_vm.disabled && _vm.isOld,
                            expression: "editable&&!disabled&&isOld",
                          },
                        ],
                        attrs: { label: "LBLREMOVE", icon: "delete" },
                        on: { btnClicked: _vm.deleteInfo },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && !_vm.disabled,
                            expression: "editable&&!disabled",
                          },
                        ],
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.check,
                          mappingType: _vm.mappingType,
                          label: "LBLSAVEALL",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveInfo,
                          btnCallback: _vm.saveCallback,
                        },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable && !_vm.disabled && _vm.isOld,
                            expression: "editable&&!disabled&&isOld",
                          },
                        ],
                        attrs: {
                          url: _vm.completeUrl,
                          isSubmit: _vm.isComplete,
                          param: _vm.check,
                          mappingType: "PUT",
                          label: "LBLCOMPLETE",
                          icon: "check",
                        },
                        on: {
                          beforeAction: _vm.completeInfo,
                          btnCallback: _vm.completeCallback,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        label: "점검명",
                        name: "checkName",
                      },
                      model: {
                        value: _vm.check.checkName,
                        callback: function ($$v) {
                          _vm.$set(_vm.check, "checkName", $$v)
                        },
                        expression: "check.checkName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2" },
                  [
                    _c("c-select", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        codeGroupCd: "SOP_FIRE_FIGHTING_CHECK_TYPE_CD",
                        type: "edit",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "점검유형",
                        name: "sopFireFightingCheckTypeCd",
                      },
                      model: {
                        value: _vm.check.sopFireFightingCheckTypeCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.check, "sopFireFightingCheckTypeCd", $$v)
                        },
                        expression: "check.sopFireFightingCheckTypeCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        range: "",
                        default: "today",
                        label: "점검기간",
                        name: "period",
                      },
                      model: {
                        value: _vm.check.period,
                        callback: function ($$v) {
                          _vm.$set(_vm.check, "period", $$v)
                        },
                        expression: "check.period",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2" },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.check.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.check, "plantCd", $$v)
                        },
                        expression: "check.plantCd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
          [
            _c(
              "c-table",
              {
                ref: "table1",
                staticClass: "q-mt-sm",
                attrs: {
                  title: "점검 대상",
                  columns: _vm.grid.columns,
                  data: _vm.check.targets,
                  gridHeight: _vm.gridHeight,
                  editable: _vm.editable && !_vm.disabled,
                  filtering: false,
                  columnSetting: false,
                  isExcelDown: false,
                  selection: "multiple",
                  rowKey: "sopFireFightingCheckTargetId",
                },
                on: { rowClick: _vm.rowClick },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name !== "custom"
                          ? [
                              _vm._v(" " + _vm._s(props.row[col.name]) + " "),
                              _c(
                                "div",
                                { staticStyle: { "font-size": "0.8em" } },
                                [
                                  col.name === "sopFireFightingTypeName"
                                    ? [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              props.row[
                                                "sopFireFightingKindName"
                                              ]
                                            ) +
                                            ") "
                                        ),
                                      ]
                                    : _vm._e(),
                                  col.name === "fireFightingName"
                                    ? [
                                        _vm._v(
                                          " (" +
                                            _vm._s(props.row["manageNo"]) +
                                            ") "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "LBLEXCEPT", icon: "delete" },
                              on: { btnClicked: _vm.deleteTarget },
                            })
                          : _vm._e(),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "LBLADD", icon: "add" },
                              on: { btnClicked: _vm.addTarget },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7" },
          [
            _c("c-table", {
              ref: "table2",
              staticClass: "q-mt-sm",
              attrs: {
                title: _vm.select.sopFireFightingId
                  ? `[${_vm.select.fireFightingName}] 점검항목`
                  : "점검항목",
                columns: _vm.gridResult.columns,
                data: _vm.select.results,
                gridHeight: _vm.gridHeight,
                editable: _vm.editable && !_vm.disabled,
                filtering: false,
                columnSetting: false,
                isExcelDown: false,
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "customCol"
                        ? [
                            _c(_vm.imprComponent, {
                              tag: "component",
                              attrs: {
                                col: col,
                                props: props,
                                inputEditable: _vm.editable && !_vm.disabled,
                                isImmShow: true,
                                requestContentsCols: _vm.requestContentsCols,
                                tableKey: "sopFireFightingCheckTargetResultId",
                                ibmTaskTypeCd: "ITT0000180",
                                ibmTaskUnderTypeCd: "ITTU000210",
                              },
                              on: { imprChange: _vm.imprChange },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }